module.exports = __webpack_public_path__ + "img/success-v2.svg";